import React, { ReactNode } from 'react'
import { FieldProps } from 'formik'
import { Search } from '@dw/helix'

interface SearchProps extends FieldProps {
  className?: string
  id?: string
  forwardedRef?: any
  onChangeValue?: (value: string) => void
  label?: string | ReactNode | boolean
  hasHint?: boolean
  hint?: string | ReactNode
  icoLeft?: ReactNode
  icoRight?: ReactNode
  status?: 'normal' | 'error' | 'success'
  theme?: 'light' | 'dark'
  disabled?: boolean
  suggestions: string[]
}

const CustomFormikSearchField = ({ field, form, ...otherSearchProps }: SearchProps) => {
  const { touched, errors } = form
  const inputFieldErrorMessage = errors[field.name]
  const isSearchFieldTouched = touched[field.name]
  const showError = inputFieldErrorMessage && isSearchFieldTouched ? true : false
  const inputFieldStatus = showError ? 'error' : 'normal'
  return (
    <Search
      {...field}
      {...otherSearchProps}
      status={inputFieldStatus}
      hasHint={showError}
      hint={inputFieldErrorMessage}
    />
  )
}

export default React.forwardRef<HTMLInputElement, SearchProps>((props, forwardedRef) => (
  <CustomFormikSearchField {...props} forwardedRef={forwardedRef} />
))
